module.exports = __webpack_public_path__ + "static/media/perf.6e99c20a.webp";